var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('DefaultTemplate',{attrs:{"title":"","subtitle":"","steps":false}},[(_vm.$i18n.locale === 'th')?_c('PrivacyPolicyTH',{attrs:{"rule":_vm.rule}}):_c('PrivacyPolicyEN',{attrs:{"rule":_vm.rule}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }